import { User } from '@/types/authent/login.types';

export function getFirstNameAndName(user: User): string {
  return `${user.firstName} ${user.name}`;
}
